import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnDetection } from './detection';
import { SnDetectionResolution } from './detection-resolution';

export class SnDetectionFrame extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public detections: SnDetection[];

  @Expose()
  public events: any[];

  @Expose()
  public applianceSerialNumber: string;

  @Expose()
  public cameraId: string;

  @Expose()
  public createdTimestamp: Date;

  @Expose()
  public detectionsImageUrl: string;

  @Expose()
  public model: string;

  @Expose()
  public resolution: SnDetectionResolution;

  @Expose()
  public resolutionBox: SnDetectionResolution;

  @Expose()
  public timestamp: Date;

  @Expose()
  public type: string;

  @Expose()
  public detectionsFiltered: any[];

  @Expose()
  public eventsFiltered: any[];
}
